import React from 'react'
import "./MultiButtons.css" 

const MultiButtons = () => {
  return (
    <div className='MultiButton'>
        <div>
            <img src="https://www.bigbasket.com/media/uploads/banner_images/hp_topstrip_m_251022_01.png" alt="Not-Found" />
        </div>
        <div>
            <img src="https://www.bigbasket.com/media/uploads/banner_images/hp_topstrip_m_251022_02.png" alt="Not-Found" /></div>
        <div>
            <img src="https://www.bigbasket.com/media/uploads/banner_images/hp_topstrip_m_251022_03.png" alt="Not-Found" /></div>
        <div>
            <img src="https://www.bigbasket.com/media/uploads/banner_images/hp_topstrip_m_251022_04.png" alt="Not-Found" /></div>
        <div>
            <img src="https://www.bigbasket.com/media/uploads/banner_images/hp_topstrip_m_251022_05.png" alt="Not-Found" /></div>
        <div>
            <img src="https://www.bigbasket.com/media/uploads/banner_images/hp_topstrip_m_251022_06.png" alt="Not-Found" /></div>
    </div>
  )
}

export default MultiButtons